module.exports = __webpack_public_path__ + "static/media/AVK01833.8ea2ccca.jpg";